import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

export abstract class FormGroupBase
{
    private _formGroup: UntypedFormGroup;

    public abstract criarFormGroup(formBuilder: UntypedFormBuilder);

    constructor(formBuilder: UntypedFormBuilder)
    {
        this._formGroup = this.criarFormGroup(formBuilder);  
    }

    public get formGroup() { return this._formGroup;}
    public get valores() { return this._formGroup.value;}
}